import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  const [showMessage, setShowMessage] = useState(false);

  const handleContactClick = () => {
    setShowMessage(true);
    setTimeout(() => {
      window.location.href = 'mailto:uchinabridge@gmail.com';
    }, 500);
  };

  useEffect(() => {
    // Add Schema.org JSON-LD for ContactPage
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "お問い合わせ",
      "description": "お店の掲載希望やご質問など、お気軽にお問い合わせください。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contact`,
      "mainEntity": {
        "@type": "Organization",
        "name": "まーやいびーが？ Ryukyu ゆいまーる MAP",
        "email": "uchinabridge@gmail.com",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "Customer Service",
          "email": "uchinabridge@gmail.com",
          "availableLanguage": ["Japanese"]
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF8F3] via-[#FFFBF7] to-[#FFF5ED]">
      <Header />

      <div className="pt-[120px] pb-24 px-6">
        <div className="max-w-[800px] mx-auto">
          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="mb-16 text-center"
          >
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-gradient-to-r from-[#FFE8DC] to-[#FFF0E6] mb-5">
              <span className="text-[13px] font-bold bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] bg-clip-text text-transparent tracking-[1.5px] uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
                ✦ CONTACT
              </span>
            </div>
            <h1 className="text-[48px] font-bold bg-gradient-to-r from-[#19425B] to-[#FF6B35] bg-clip-text text-transparent leading-[1.3] mb-5" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              お問い合わせ
            </h1>
            <p className="text-[18px] text-[rgba(25,66,91,0.65)] leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              お店の掲載希望やご質問など、<br />
              お気軽にお問い合わせください。
            </p>
          </motion.div>

          {/* Contact Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="bg-white rounded-[24px] p-12 shadow-[0_16px_48px_rgba(255,107,53,0.12)] text-center"
          >
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#FF8C42] flex items-center justify-center">
              <i className="ri-mail-line text-[40px] text-white"></i>
            </div>

            <h2 className="text-[28px] font-bold text-[#19425B] mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              メールでお問い合わせ
            </h2>

            <p className="text-[16px] text-[rgba(25,66,91,0.7)] leading-[1.9] mb-8" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              以下のボタンをクリックすると、<br />
              メールアプリが起動します。
            </p>

            <button
              onClick={handleContactClick}
              className="inline-flex items-center gap-3 px-10 py-5 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white text-[16px] font-bold shadow-[0_8px_24px_rgba(255,107,53,0.3)] hover:shadow-[0_12px_32px_rgba(255,107,53,0.4)] hover:-translate-y-1 transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <i className="ri-mail-send-line text-[22px]"></i>
              メールを送る
            </button>

            <div className="mt-8 pt-8 border-t border-[rgba(255,107,53,0.1)]">
              <p className="text-[15px] text-[rgba(25,66,91,0.6)] mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                メールアドレス
              </p>
              <a
                href="mailto:uchinabridge@gmail.com"
                className="text-[18px] font-semibold text-[#FF6B35] hover:text-[#FF8C42] transition-colors cursor-pointer"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                uchinabridge@gmail.com
              </a>
            </div>

            {/* Thank You Message */}
            {showMessage && (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
                className="mt-8 p-6 rounded-[16px] bg-gradient-to-r from-[#FFE8DC] to-[#FFF0E6]"
              >
                <div className="flex items-center justify-center gap-3 mb-2">
                  <i className="ri-check-line text-[24px] text-[#FF6B35]"></i>
                  <p className="text-[18px] font-bold text-[#19425B]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    お問い合わせありがとうございます
                  </p>
                </div>
                <p className="text-[15px] text-[rgba(25,66,91,0.7)]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  担当者より返信いたします。
                </p>
              </motion.div>
            )}
          </motion.div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6"
          >
            <div className="bg-white rounded-[20px] p-8 shadow-[0_8px_32px_rgba(255,107,53,0.08)]">
              <div className="w-12 h-12 mb-4 rounded-full bg-gradient-to-br from-[#FFE8DC] to-[#FFF0E6] flex items-center justify-center">
                <i className="ri-store-2-line text-[24px] text-[#FF6B35]"></i>
              </div>
              <h3 className="text-[20px] font-bold text-[#19425B] mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                お店の掲載について
              </h3>
              <p className="text-[14px] text-[rgba(25,66,91,0.7)] leading-[1.8]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                琉球人オーナーとして営業されているお店の掲載を無料で受け付けています。
              </p>
            </div>

            <div className="bg-white rounded-[20px] p-8 shadow-[0_8px_32px_rgba(255,107,53,0.08)]">
              <div className="w-12 h-12 mb-4 rounded-full bg-gradient-to-br from-[#FFE8DC] to-[#FFF0E6] flex items-center justify-center">
                <i className="ri-question-line text-[24px] text-[#FF6B35]"></i>
              </div>
              <h3 className="text-[20px] font-bold text-[#19425B] mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                その他のお問い合わせ
              </h3>
              <p className="text-[14px] text-[rgba(25,66,91,0.7)] leading-[1.8]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                サイトに関するご質問やご意見など、お気軽にお寄せください。
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
